<script lang="ts">
    import { Route, Router, Link, useLocation } from "svelte-navigator";
    import Loading from "../Loading.svelte";
    import CampaignList from "./CampaignList.svelte";
    import ProductList from "./ProductList.svelte";
    import DocumentList from "./DocumentList.svelte";
    import ProductForm from "./ProductForm.svelte";
    import Statistics from "./Statistics.svelte";
    import History from "./History.svelte";

    let location = useLocation();
</script>

<style lang="scss">
    @import "../styles/variables.scss";
    .tabs {
        ul {

            li.unselectable {
                span {
                    color: #b3b3b3;
                    padding: 1em;
                }

            }

            li  {

                &.is-active {
                    border-bottom-color: $dark-black !important;
                    color: $dark-black !important;
                    span {
                        border-bottom-color: $dark-black !important;
                        color: $dark-black !important;
                    }
                }
            }

        }
    }

    #content {
        height: calc(100% - 112px);
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>

<Loading/>

<div class="tabs is-centered mb-0 pt-1">
    <ul>
        <li class="{$location.pathname.split('/').length == 2 ? 'is-active' : ''}">
            <Link to="">
                <span>Opérations</span>
            </Link>
        </li>
        <li class="{$location.pathname.split('/')[2] == 'documents' ? 'is-active' : ''}">
            <Link to="documents">
                <span>Versions</span>
            </Link>
        </li>
        <li class="unselectable {$location.pathname.split('/')[2] == 'products' ? 'is-active' : ''}">
            <span>Produits</span>
        </li>
    </ul>
</div>

<div id="content" class="container-fluid p-3">
    <Router>
        <Route path="/">
            <CampaignList/>
        </Route>
        <Route path="/documents">
            <DocumentList></DocumentList>
        </Route>
        <Route path="/products/:document_uid" component="{ProductList}"></Route>
        <Route path="/product" component="{ProductForm}"></Route>
        <Route path="/product/:document_uid/:product_uid" component="{ProductForm}"></Route>
        <Route path="/products/:document_uid/new" component="{ProductForm}"></Route>
        <Route path="/statistics" component="{Statistics}"></Route>
        <Route path="/logs" component="{History}"></Route>
    </Router>
</div>
